export const InfoCode = {
  specificLocation: '6005',
  vesselType: '6011',
  vesselTypeOther: '6011',
  boilerType: '6022',
  boilerTypeOther: '6023',
  liftType: '6033',
  liftTypeOther: '6034',
  amusementDeviceName: '6047',
  amusementDeviceType: '6049',
  amusementDeviceTypeOther: '6050',
  electricalInstallation: '6051',
  towerCraneType: '6065',
  mobileCraneType: '6069',
  mobileCraneTypeOther: '6070',
  customersUid: '6075',
  concretePlacingBoomType: '6079',
  engineeringInspectionConditionsAmusementDevice: '6088',
  engineeringInspectionConditionsTowerCrane: '6090',
  electricalInspectionConditions: '6094',
  information: '6199',
  expiryDate: '6203',
};
